export default {
    header: {
        title: 'News Feed',
    },
    followingAndIgnore: {
        following: 'Following',
        users: 'users',
        followingMe: 'Followers',
        ignoring: 'Ignoring',
        followingMeShort: 'Followers',
    },
    toolbar: {
        title: 'News',
        yourNews: 'Your News',
        onlyOnline: 'Only online',
        onlyOnlineModels: 'Show only online models',
        searchPlaceholder: 'Search news',
        checkingLatest: 'Checking for latest\u2026',
        searchBy: 'Search by',
        searchByNews: 'News',
        searchByUsername: 'Username',
    },
    guestNotice: {
        guestReason: 'to follow models for their latest news updates and more',
        basicReason: 'to post your own news and more',
    },
    feeds: {
        subscriptions_friends: 'Following & Friends',
        subscriptions: 'Following',
        all_models: 'All Models News',
        all_news: 'All Models & Members',
        myfreecams_news: 'MyFreeCams News',
        my_news: 'My Posts',
        recent_models: 'Past 24 hours',
    },
    row: {
        allNews: 'All news',
        delete: 'Delete',
        follow: 'Follow',
        following: 'Following',
        ignore: 'Ignore',
        followed: 'Following',
        unfollowed: 'Unfollowing',
    },
    yourNews: {
        title: 'Your News',
        network: 'Your network',
        showNewsIn: 'Show news in',
        following: 'Following',
        followers: 'Followers',
        ignoring: 'Ignoring',
        unfollow: 'Stop following',
        unignore: 'Stop ignoring',
        followBack: 'Follow back',
        followed: 'Followed',
        removed: 'Removed',
        showAll: 'Show all',
        premiumOnly:
            'Followers and ignored users are available to premium members.',
        actionFailed: 'That change could not be saved. Please try again.',
    },
    compose: {
        title: 'Compose News Post',
        placeholder: "What's new",
        post: 'Post',
        clickHere: 'Post News Feed message',
        label: 'Type your news here',
        charactersRemaining: 'character(s) left',
        charactersOver: 'character(s) too many',
        success: 'Your news item has been posted.',
        failed: 'Post failed. Try again.',
        noAccess: 'Only premium members can post news.',
    },
    display: {
        displayNewsFrom: 'Display from',
        onlyOnlineModels: 'Only Online',
        byCamscore: 'By CamScore',
    },
    newsCell: {
        minuteAgo: 'minute ago',
        minutesAgo: 'minutes ago',
        online: 'Online',
        viewAll: 'View All News from',
        follow: 'Follow',
        ignore: 'Ignore',
        on: 'on',
        at: 'at',
    },
    // not implemented in first pass; adding for future
    updates: {
        receive: 'Receive news updates in',
        chat: 'Chat Rooms',
        pm: 'Private Messages',
        privateShows: 'Private Shows',
        groupShows: 'Group & Club Shows',
        fromFriends: 'Display news from friends',
    },
    searchBy: {
        noResults: 'There are no news items to display.',
        searchBy: 'Search By',
        showing: 'Showing news matching',
        type: 'news',
    },
    tabs: {
        news: 'News Feed',
        search: 'Search News',
    },
    list: {
        notIgnoring: 'You are not ignoring any users.',
        notFollowing: 'You are not following any users.',
        nobodyFollowingYou: 'No users following you.',
        clickToRemoveIgnore: 'Select a user to stop ignoring them.',
        clickToRemoveFollowee: 'Select a user to stop following them.',
        clickToAddFollower:
            'Select a user that is following you to follow them back.',
    },
    newsSettings: {
        title: 'News Notifications',
        headerAlertSettings: 'Header Alert Settings',
    },
}
